import { createSlice } from "@reduxjs/toolkit";
import {
  fetchEngagementAction,
  fetchWeightingsAction,
  fetchTopVideosAction,
  fetchUsersAction,
  fetchVideoStatsAction,
} from "../Action/userContentAction";

const initialState = {
  engagement: [],
  weightings: [],
  topVideos: [],
  users: [],
  videoStats: null,
  isLoading: false,
  error: null,
};

const userContentSlice = createSlice({
  name: "userContent",
  initialState,
  reducers: {
    clearUserContentError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Engagement
    builder.addCase(fetchEngagementAction.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchEngagementAction.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.engagement = payload?.data || payload || [];
    });
    builder.addCase(fetchEngagementAction.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    });

    // Weightings
    builder.addCase(fetchWeightingsAction.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchWeightingsAction.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.weightings = payload?.data || payload || [];
    });
    builder.addCase(fetchWeightingsAction.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    });

    // Top Videos
    builder.addCase(fetchTopVideosAction.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchTopVideosAction.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.topVideos = payload?.data || payload || [];
    });
    builder.addCase(fetchTopVideosAction.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    });

    // Users
    builder.addCase(fetchUsersAction.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchUsersAction.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.users = payload?.data || payload || [];
    });
    builder.addCase(fetchUsersAction.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    });

    // Video Stats
    builder.addCase(fetchVideoStatsAction.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchVideoStatsAction.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.videoStats = payload?.data || payload || null;
    });
    builder.addCase(fetchVideoStatsAction.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    });
  },
});

export const { clearUserContentError } = userContentSlice.actions;
export default userContentSlice.reducer;
